import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ExtendedRecord, FindingItem } from '../../med-view.component';

@Component({
  selector: 'app-finding-list',
  templateUrl: './finding-list.component.html',
  styleUrls: ['./finding-list.component.scss'],
  standalone: true,
  imports: [NgForOf, NgIf, DatePipe, NgClass],
})
export class FindingListComponent {
  @Input({ required: true }) findingsList!: FindingItem<any>[];
  @Input({ required: true }) currentRecord!: ExtendedRecord | undefined;

  @Output() changeSelectedFinding: EventEmitter<FindingItem<any>> = new EventEmitter<
    FindingItem<any>
  >();

  public selectFinding(fl: FindingItem<any>) {
    this.changeSelectedFinding.emit(fl);
  }
}
